import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnTriangleAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M12 8.318v4.763m-.005 2.914h.009M12 19.965H6.546c-3.123 0-4.429-2.233-2.916-4.96l2.808-5.059 2.646-4.753c1.603-2.889 4.231-2.889 5.833 0l5.455 9.82c1.512 2.728.198 4.96-2.916 4.96H12z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnTriangleAlert;
